var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _path, _path2, _circle, _circle2, _circle3, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen08Map(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 780",
    width: 360,
    height: 780,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 780,
    fill: "#0c1218"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 19,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 19,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 18,
    width: 20,
    height: 10,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 12,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#000",
    opacity: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 360,
    height: 520,
    rx: 0,
    fill: "#0f1a22",
    opacity: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: 0,
    width: 3,
    height: 520,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 0,
    width: 3,
    height: 520,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 0,
    width: 3,
    height: 520,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 0,
    width: 3,
    height: 520,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 0,
    width: 3,
    height: 520,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 0,
    width: 3,
    height: 520,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 0,
    width: 3,
    height: 520,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 0,
    width: 3,
    height: 520,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 0,
    width: 3,
    height: 520,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 0,
    width: 3,
    height: 520,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20,
    width: 360,
    height: 3,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 66,
    width: 360,
    height: 3,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 112,
    width: 360,
    height: 3,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 158,
    width: 360,
    height: 3,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 204,
    width: 360,
    height: 3,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 250,
    width: 360,
    height: 3,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 296,
    width: 360,
    height: 3,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 342,
    width: 360,
    height: 3,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 388,
    width: 360,
    height: 3,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 434,
    width: 360,
    height: 3,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 480,
    width: 360,
    height: 3,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 526,
    width: 360,
    height: 3,
    rx: 0,
    fill: "#233142",
    opacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-10,420 Q80,380 120,300 T260,180 T380,120",
    stroke: "#34424f",
    strokeWidth: 14,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60,440 L60,360 Q60,330 90,330 L200,330 Q230,330 230,300 L230,190 Q230,160 260,160 L300,160",
    stroke: "#5ce1e6",
    strokeWidth: 5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 440,
    r: 9,
    fill: "#dfe6e8",
    opacity: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 160,
    r: 22,
    fill: "#5ce1e6",
    opacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 160,
    r: 10,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 0.9
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 19,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 19,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 18,
    width: 20,
    height: 10,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 12,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#000",
    opacity: 1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 480,
    width: 360,
    height: 300,
    rx: 26,
    fill: "#141d27",
    opacity: 1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 492,
    width: 44,
    height: 5,
    rx: 2.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 516,
    width: 160,
    height: 12,
    rx: 6,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 538,
    width: 110,
    height: 7,
    rx: 3.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 566,
    width: 96,
    height: 64,
    rx: 14,
    fill: "#1a2531",
    opacity: 1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 584,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 600,
    width: 56,
    height: 10,
    rx: 5,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 566,
    width: 96,
    height: 64,
    rx: 14,
    fill: "#1a2531",
    opacity: 1
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 584,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 600,
    width: 56,
    height: 10,
    rx: 5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 566,
    width: 96,
    height: 64,
    rx: 14,
    fill: "#1a2531",
    opacity: 1
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 584,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 600,
    width: 56,
    height: 10,
    rx: 5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 652,
    width: 312,
    height: 52,
    rx: 26,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 674,
    width: 100,
    height: 9,
    rx: 4.5,
    fill: "#05070a",
    opacity: 1
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 766,
    width: 120,
    height: 5,
    rx: 2.5,
    fill: "#dfe6e8",
    opacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen08Map);
export default __webpack_public_path__ + "static/media/screen-08-map.ee7562faf352f43ce2a80d5ceaba0ecc.svg";
export { ForwardRef as ReactComponent };